var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.statusColor}},[_c('span',[_c('feather-icon',{attrs:{"icon":_vm.statusIcon,"size":5}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }